import PropTypes from "prop-types";
import { AdminMenuSection } from "./MenuComponents";
import {
  facilityAdminMenuConfig,
  globalAdminMenuConfig,
} from "./adminMenuConfigs";

const AdminMenuSections = ({
  showGlobalAdmin,
  showFacilityAdmin,
  facilityType,
  navStyle,
}) => (
  <>
    {showGlobalAdmin && (
      <AdminMenuSection config={globalAdminMenuConfig} navStyle={navStyle} />
    )}
    {showFacilityAdmin && (
      <AdminMenuSection
        config={facilityAdminMenuConfig}
        facilityType={facilityType}
        navStyle={navStyle}
      />
    )}
  </>
);

AdminMenuSections.propTypes = {
  showGlobalAdmin: PropTypes.bool,
  showFacilityAdmin: PropTypes.bool,
  facilityType: PropTypes.string,
  navStyle: PropTypes.string,
};

export default AdminMenuSections;
